import { StoreState } from '@/core/models/store.interface';
import { ActionContext } from 'vuex';
import { ActionService } from './action.service';

const service = new ActionService();

export interface ActionState {}

const state: ActionState = {};

const getters = {};

const mutations = {};

const actions = {
   async sendActionMail(context: ActionContext<ActionState, StoreState>, userId: number) {
      return await service.sendActionMail(userId);
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
